import { SERVER_URL } from "../../../../constants.js";

function getToken() {
  return sessionStorage.getItem("bearer");
}

async function parseBody(res) {
  const text = await res.text().catch(() => "");
  if (!text) return null;
  try { return JSON.parse(text); } catch { return text; }
}

async function request(path, { method = "GET", body, query } = {}) {
  const token = getToken();

  let url = `${SERVER_URL}${path.replace(/^\//, "")}`;
  if (query) {
    const qs = new URLSearchParams(
      Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== "")
    ).toString();
    if (qs) url += `?${qs}`;
  }

  const res = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 204) return null;

  const parsed = await parseBody(res);

  if (!res.ok) {
    const message =
      (parsed && typeof parsed === "object" && (parsed.message || parsed.error)) ||
      (typeof parsed === "string" && parsed) ||
      `${method} ${path} failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.body = parsed;
    throw err;
  }

  return parsed;
}

export const qbHttp = { request };
